import React from "react";
import LngReport from "components/app/report/lng/LngReport";

type ScreenLngReportProps = React.PropsWithChildren<{}>;

function ScreenLngReport(props: ScreenLngReportProps) {
	return <LngReport />;
}

export default ScreenLngReport;
